<app-header-content-footer *transloco="let t"
  [headerTitle]="t('point-balance')">
  <app-sidenav-content content showBanner>
    <app-point-balance content [business]="business" [isMobile]="isMobile"></app-point-balance>
  </app-sidenav-content>
</app-header-content-footer> 
